app.service('previewOrder', function (broker, loading, modal, deliveryLocation, deliveryPoints, ajaxOrder, front) {

	function refresh(callback) {
		loading.start();
		$.ajax({
			url: '/order-path-preview.ltr',
			dataType: "json",
			data: {
				refresh: true
			},
			success: function (json) {
				loading.stop();

				let $box = $('#preview-list');
				$box.html(json.previewRight);
				let $box2 = $('#preview-order-steps');
				$box2.html(json.previewLeft);
				if (callback) {
					callback();
				}
				$box.attr('wdio-ready', parseInt(Math.random()*1000000000));
				broker.trigger('PREVIEW_REFRESH');
			},
			error: function () {
				modal.alert('Błąd odświeżenia stanu zamówienia. Strona zostanie odświeżona.', function () {
					loading.reload();
				});
			}
		});
	}

	function changePriceDisplayType(action) {
		loading.start();
		if(front.page() == 'basket'){
			$.ajax({
				url: '/cart-change-price-type.ltr',
				cache: false,
				dataType: 'json',
				type: 'POST',
				data: {
					priceType: action,
					refresh: true
				},
				success: function () {
					broker.trigger('REFRESH_BASKET_VIEW');
				},
				error: function () {
					loading.stop();
					modal.alert('Błąd zmiany kontekstu koszyka. Spróbuj ponownie');
				}
			});
		} else {
			$.ajax({
				url: '/order-path-change-price-type.ltr',
				cache: false,
				dataType: 'json',
				type: 'POST',
				data: {
					priceType: action,
					refresh: true
				},
				success: function () {
					refresh();
				},
				error: function () {
					loading.stop();
					modal.alert('Błąd zmiany kontekstu ścieżki zakupowej. Spróbuj ponownie');
				}
			});
		}
	}

	let isOneInit = false;
	function init() {
		if(!isOneInit){
			isOneInit = true;
			$('body').on('click', '.js-show-more-products', function () {
				$(this).closest('.basket-list').toggleClass('show-all');
			}).on('click', '.js-show-user-data', function () {
				$('#short-client-data').remove();
				$.scrollTo($('#returning-user-data-box'),100);
			}).on('click', '.js-scroll-delivery-time', function () {
				$.scrollTo($('form'));
			}).on('click', '.js-k4-edit', function(){
			}).on('click', '.js-scroll-payment', function () {
				$.scrollTo($('form'));
			}).on('click', '.js-price-installment', function () {
				changePriceDisplayType('INSTALMENT');
			}).on('click', '.js-price-normal', function () {
				changePriceDisplayType('NORMAL');
			}).on('click', '.js-show-shops', function () {
				$('#preview-order-steps .row-delivery-point').hide();
				$('#container').removeClass('hide-shops');
				deliveryLocation.show();
			}).on('click', '.js-show-inpost, .js-show-points', function () {
				$('#preview-order-steps .row-delivery-point').hide();
				$('#container').removeClass('hide-points');
				var $this = $(this);
				deliveryPoints.show({
					longitude: $this.data('longitude'),
					latitude: $this.data('latitude'),
					point: $this.data('point')
				});
				$.scrollTo($('#delivery-points'), 100);
			}).on('click', '.js-nav-back, .js-nav-step, .js-back-to-edit', function(event){
				let $this = $(this);
				let href = $this.attr('href');
				if (href && href.length && testAB.getVar('ajax-order') === 'B' && front.getParam('ajaxOrder')) {
					ajaxOrder.get({
						href: href,
						scroll: $this.data('scroll'),
						click: $this.data('click')
					});
					event.preventDefault();
					//event.stopPropagation();
				}
			});
			broker.on('K3_REFRESH', function (event, callback) {
				refresh(callback);
			});
			broker.on('PREVIEW_REFRESH', function (event) {
				//marketingDescription();
			});
		}
	}
	return {
		init
	};
});
